var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmoji(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.664A7.333 7.333 0 118 16.33 7.333 7.333 0 018 1.664zm0 1.333a6 6 0 100 12 6 6 0 000-12zm2.183 7.54a.668.668 0 01.967.919c-1.005 1.058-2.056 1.611-3.15 1.611-1.094 0-2.145-.553-3.15-1.61a.667.667 0 11.967-.919c.773.814 1.499 1.196 2.183 1.196.684 0 1.41-.382 2.183-1.196zM6.007 6.331a.667.667 0 010 1.334A.667.667 0 116 6.331zm4 0a.667.667 0 010 1.334A.667.667 0 1110 6.331z",
    fill: "#242931",
    fillRule: "evenodd"
  })));
}
export default SvgIconEmoji;